export default __webpack_public_path__ + "static/media/SpiralCloudBGFull.f9e73f2b.png";